<template>
    <div class="card card-with-shadow border-0 mb-primary">

        <app-overlay-loader v-if="preloader"/>
            <form ref="form" :data-url="selectedUrl ? `admin/app/careersites/1` : `admin/app/careersites`" class="mb-0" :class="{'loading-opacity': preloader}">

                <div class="tools-right-top guide-step-carreersite-1">

                    <label class="input-color-label" for="input-color">
                        {{ $t('choose_company_color') }}
                    </label>
                    <div class="form-control-color-container">
                        <app-input type="color"
                                   id="input-color"
                                   v-model="header.color"
                                   @change="changeColor"/>
                    </div>

                </div>



                <div class="card-body-rounded site-container career-site">

                    <!-- Start of header -->
                    <section class="hero-container" :style="`background-image: url('`+this.inputs.images.header+`');`">

                        <button type="submit" class="btn btn-primary btn-sm btn-top-right change-background-btn" @click.prevent="addImageTo('header');">
                            <app-icon :name="'image'" width="25" height="25"/>
                            {{ $t('change_background') }}
                        </button>

                        <div class="row container-lg nav">
                            <div class="col-sm-4">
                                    <div v-for="image in this.inputs.images.logo" class="float-left mr-2">
                                        <img :src="image" height="60">
                                    </div>

                                <button type="submit" class="btn btn-primary btn-sm btn-right btn-top-right-logo" @click.prevent="addImageTo('logo');">
                                    <app-icon :name="'image'" width="25" height="25"/>
                                    {{ $t('change_logo') }}
                                </button>

                            </div>
                            <div class="text-right right-indent">
                                <app-input  v-if="finishedGetData"
                                            class="col-sm-12 small-editor"
                                            type="text-editor"
                                            v-model="header.nav"
                                            :placeholder="$t('text_type_input')"
                                />
                                <div class="badge-circle">
                                    {{ this.advertsCount }}
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-center flex-column full-height-column main-headline">
                            <div class="p-2">
                                <app-input  v-if="finishedGetData"
                                            class="col-sm-12 medium-editor"
                                            type="text-editor"
                                            v-model="header.text"
                                            :placeholder="$t('text_type_input')"
                                />

                            </div>
                            <div class="p-2">
                                <app-input  v-if="finishedGetData"
                                            class="col-sm-12 small-editor"
                                            type="text-editor"
                                            v-model="header.button"
                                            :placeholder="$t('text_type_input')"
                                />

                            </div>
                        </div>

                    </section>




                    <!-- Start of body -->
                    <section class="body-container container-lg row">
                        <div class="col-sm-12 col-md-6 images">

                            <app-input  v-if="finishedGetData"
                                class="col-sm-12"
                                type="text-editor"
                                v-model="body.text1"
                                :placeholder="$t('text_type_input')"
                                />

                            <div v-for="image in this.inputs.images.body1" class="col-sm-12">
                                <button type="submit" class="btn btn-secondary btn-sm btn-circle btn-top-right" @click.prevent="removeImageFromChosenPlace(image, 'body1')">
                                    <app-icon :name="'trash'" width="25" height="25"/>
                                </button>

                                <img :src="image">
                            </div>
                            <div class="col-sm-12 text-center">
                                <button type="submit" class="btn btn-primary btn-sm" @click.prevent="addImageTo('body1');">
                                    <app-icon :name="'plus'" width="25" height="25"/> {{ $t('add_image') }}
                                </button>
                            </div>

                            <app-input  v-if="finishedGetData"
                                        class="col-sm-12 mb-2"
                                        type="text-editor"
                                        v-model="body.text2"
                                        :placeholder="$t('text_type_input')"
                                        />

                            <div v-for="image in this.inputs.images.body2" class="col-sm-12">
                                <button type="submit" class="btn btn-secondary btn-sm btn-circle btn-top-right" @click.prevent="removeImageFromChosenPlace(image, 'body2')">
                                    <app-icon :name="'trash'" width="25" height="25"/>
                                </button>

                                <img :src="image">
                            </div>
                            <div class="col-sm-12 text-center">
                                <button type="submit" class="btn btn-primary btn-sm" @click.prevent="addImageTo('body2');">
                                    <app-icon :name="'plus'" width="25" height="25"/> {{ $t('add_image') }}
                                </button>
                            </div>

                            <app-input  v-if="finishedGetData"
                                        class="col-sm-12"
                                        type="text-editor"
                                        v-model="body.text3"
                                        :placeholder="$t('text_type_input')"
                                        />

                        </div>
                        <div class="col-sm-12 col-md-6 images">
                            <div v-for="image in this.inputs.images.body3" class="col-sm-12">
                                <button type="submit" class="btn btn-secondary btn-sm btn-circle btn-top-right" @click.prevent="removeImageFromChosenPlace(image, 'body3')">
                                    <app-icon :name="'trash'" width="25" height="25"/>
                                </button>

                                <img :src="image">
                            </div>
                            <div class="col-sm-12 text-center">
                                <button type="submit" class="btn btn-primary btn-sm" @click.prevent="addImageTo('body3');">
                                    <app-icon :name="'plus'" width="25" height="25"/> {{ $t('add_image') }}
                                </button>
                            </div>

                            <app-input  v-if="finishedGetData"
                                        class="col-sm-12"
                                        type="text-editor"
                                        v-model="body.text4"
                                        :placeholder="$t('text_type_input')"
                                        />

                            <div v-for="image in this.inputs.images.body4" class="col-sm-12">
                                <button type="submit" class="btn btn-secondary btn-sm btn-circle btn-top-right" @click.prevent="removeImageFromChosenPlace(image, 'body4')">
                                    <app-icon :name="'trash'" width="25" height="25"/>
                                </button>

                                <img :src="image">
                            </div>
                            <div class="col-sm-12 text-center">
                                <button type="submit" class="btn btn-primary btn-sm" @click.prevent="addImageTo('body4');">
                                    <app-icon :name="'plus'" width="25" height="25"/> {{ $t('add_image') }}
                                </button>
                            </div>

                            <app-input  v-if="finishedGetData"
                                        class="col-sm-12"
                                        type="text-editor"
                                        v-model="body.text5"
                                        :placeholder="$t('text_type_input')"
                                        />
                        </div>

                    </section>




                    <!-- Start of fullsize container -->
                    <section class="fullsize-container flex-container mb-0">
                        <article class="container-lg row">
                        <div class="col-sm-12 col-md-6 images">
                            <div v-for="image in this.inputs.images.fullsize">
                                <button type="submit" class="btn btn-secondary btn-sm btn-circle btn-top-right" @click.prevent="removeImageFromChosenPlace(image, 'fullsize')">
                                    <app-icon :name="'trash'" width="25" height="25"/>
                                </button>

                                <img :src="image">
                            </div>
                            <button type="submit" class="btn btn-primary btn-sm" @click.prevent="addImageTo('fullsize');">
                                <app-icon :name="'plus'" width="25" height="25"/> {{ $t('add_image') }}
                            </button>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <app-input v-if="finishedGetData"
                                type="text-editor"
                                v-model="fullsize.text1"
                                :placeholder="$t('text_type_input')"
                                />

                        </div>
                        </article>
                    </section>



                                            <!-- Start of fullsize container -->
                                            <section class="fullsize-container footer">
                                                <article class="container-lg col-sm-12 text-center pt-5">
                                                    <strong>Pracovní příležitosti</strong>
                                                    <div class="badge-circle">
                                                        {{ this.advertsCount }}
                                                    </div>

                                                    <div class="mt-5 mb-5 text-center">

                                                        <div class="row career-list">
                                                            <div v-for="advert in this.adverts" class="col-sm-12 col-md-6 col-lg-4 panel">
                                                                <a :href="advert.url" target="_blank">
                                                                    <div>
                                                                        <h2>{{ advert.job }}</h2>
                                                                        <div class="location">{{ advert.location }}</div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>

                                                    </div>


                                                </article>
                                            </section>





                    <!-- Start of prefooter container -->
                    <section class="body-container container-lg row">
                        <div class="col-sm-12 col-md-6">
                            <app-input  v-if="finishedGetData"
                                        class="col-sm-12"
                                        type="text-editor"
                                        v-model="prefooter.text1"
                                        :placeholder="$t('text_type_input')"
                                        />
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <app-input  v-if="finishedGetData"
                                        class="col-sm-12"
                                        type="text-editor"
                                        v-model="prefooter.text2"
                                        :placeholder="$t('text_type_input')"
                                        />
                        </div>
                    </section>


                    <!-- Start of footer container -->
                    <section class="footer-container container-lg row">

                        <div class="col-sm-12">
                        <app-input  v-if="finishedGetData"
                                    class="col-sm-12"
                                    type="text-editor"
                                    v-model="footer.text1"
                                    :placeholder="$t('text_type_input')"
                                    />
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <app-input  v-if="finishedGetData"
                                        class="col-sm-12"
                                        type="text-editor"
                                        v-model="footer.text2"
                                        :placeholder="$t('text_type_input')"
                                        />
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <app-input  v-if="finishedGetData"
                                        class="col-sm-12"
                                        type="text-editor"
                                        v-model="footer.text3"
                                        :placeholder="$t('text_type_input')"
                                        />
                        </div>

                        <div class="col-sm-12 col-sm-12 offset-md-3 col-md-6">
                        <app-input  v-if="finishedGetData"
                                    class="col-sm-12"
                                    type="text-editor"
                                    v-model="footer.text4"
                                    :placeholder="$t('text_type_input')"
                                    />
                        </div>


                        <div class="col-sm-12 offset-md-2 col-md-8 text-center">
                            <div v-for="image in this.inputs.images.footer" class="mt-3 mb-3">
                                <button type="submit" class="btn btn-secondary btn-sm btn-circle btn-top-right" @click.prevent="removeImageFromChosenPlace(image, 'footer')">
                                    <app-icon :name="'trash'" width="25" height="25"/>
                                </button>

                                <img :src="image" width="100%">
                            </div>
                            <button type="submit" class="btn btn-primary btn-sm" @click.prevent="addImageTo('footer');">
                                <app-icon :name="'plus'" width="25" height="25"/> {{ $t('add_image') }}
                            </button>
                        </div>

                        </section>





                    <div class="footer-bottom-fixed">
                        <a href="" target="_blank" class="btn btn-light mr-2 d-none">
                            {{ $t('preview') }}
                        </a>
                        <button type="submit" class="btn btn-primary btn-with-icon" @click.prevent="submit">
                            <i class="custom-icon-set custom-icon-set-check"></i>
                            {{ $t('save_changes_on_site') }}
                        </button>
                    </div>

                </div>

            </form>

    </div>
</template>

<script>
    import {FormMixin} from '../../../../../../../core/mixins/form/FormMixin.js';
    import GlobalHelperMixin from '../../../../../../Mixins/global/GlobalHelperMixin';

    export default {
        name: "SiteEditor",
        mixins: [FormMixin, GlobalHelperMixin],
        props: {
            uploadedImage: {
                required: false,
                type: Object,
            },
        },
        watch: {
          uploadedImage: {
            // the callback will be called immediately after the start of the observation
            immediate: true,
            handler (val, oldVal) {

                // If new file has been uploaded
                if(oldVal){
                    this.insertImageToChosenPlace(val.input.default_file);
                }

            }
          }
        },
        data() {
            return {
                preloader: false,
                tableCommentId: 'comments-table',
                finishedGetData: false,
                chosenPlace: '',
                inputs: {
                    header: '',
                    body: '',
                    fullsize: '',
                    prefooter: '',
                    footer: '',
                    images: '',
                },
                header: {
                    color: '',
                    nav: '',
                    button: '',
                    text: '',
                },
                body: {
                    text1: '',
                    text2: '',
                    text3: '',
                    text4: '',
                    text5: '',
                },
                fullsize: {
                    text1: ''
                },
                prefooter: {
                    text1: '',
                    text2: ''
                },
                footer: {
                    text1: '',
                    text2: '',
                    text3: '',
                    text4: ''
                },
                adverts: {},
                advertsCount: '',
            }
        },
        created() {
            if (this.selectedUrl) {
                this.modalTitle = this.$t('edit');
                this.preloader = true;
            } else {
                this.finishedGetData = true;
            }

            window.onscroll = function() {
                var pageHeight = document.documentElement.offsetHeight,
                windowHeight = window.innerHeight,
                scrollPosition = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);


                if (scrollPosition > 193 && window.innerWidth > 991) {
                    $('.right-indent').addClass('fixed');
                } else {
                    $('.right-indent').removeClass('fixed');
                }

                $('.main-headline .note-editable').trigger('click');
            };

        },
        mounted() {
            $( "#sidebar" ).mouseenter(function() {
                $(".card-header").removeClass("active");
                $("#sidebar").focus();
            });

            if ($(".site-container").length > 0){
                $('body').addClass('careersite-editor');
            }

            $('body').on('click', '.editor', function() {
                $('.floating-bar-fixed-bottom').hide();
            });

            $('body').on('click', '.images .btn, .btn-right, .btn-top-right', function() {
                $('.floating-bar-fixed-bottom').show();
            });




        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
                // Fill form inputs with content from multiple fields
                this.inputs.header = '{"color":'+JSON.stringify(this.header.color)+', "nav":'+JSON.stringify(this.header.nav)+', "text":'+JSON.stringify(this.header.text)+', "button":'+JSON.stringify(this.header.button)+'}';
                this.inputs.body = '{"text1":'+JSON.stringify(this.body.text1)+', "text2":'+JSON.stringify(this.body.text2)+', "text3":'+JSON.stringify(this.body.text3)+', "text4":'+JSON.stringify(this.body.text4)+', "text5":'+JSON.stringify(this.body.text5)+'}';
                this.inputs.fullsize = '{"text1":'+JSON.stringify(this.fullsize.text1)+'}';
                this.inputs.prefooter = '{"text1":'+JSON.stringify(this.prefooter.text1)+', "text2":'+JSON.stringify(this.prefooter.text2)+'}';
                this.inputs.footer = '{"text1":'+JSON.stringify(this.footer.text1)+',"text2":'+JSON.stringify(this.footer.text2)+',"text3":'+JSON.stringify(this.footer.text3)+',"text4":'+JSON.stringify(this.footer.text4)+'}';

                // console.log(this.inputs.header);
                this.save(this.inputs);

            },
            afterFinalResponse() {
                // console.log('afterFinalResponse');
                this.preloader = false;
                $( "#profileDropdown" ).focus();
                this.$hub.$emit('reload-'+this.tableCommentId);
            },
            afterSuccessFromGetEditData(response) {
                // console.log('load data'+response.data.header);
                let headerContentf = JSON.parse(response.data.header);


                // Fill every input
                if(response.data.header && response.data.updated_at != "2022-01-01T00:01:00.000000Z"){
                    if(response.data.header){
                        this.header = JSON.parse(response.data.header);
                    }
                    if(response.data.body){
                        this.body = JSON.parse(response.data.body);
                    }
                    if(response.data.fullsize){
                        this.fullsize = JSON.parse(response.data.fullsize);
                    }
                    if(response.data.prefooter){
                        this.prefooter = JSON.parse(response.data.prefooter);
                    }
                    if(response.data.footer){
                        this.footer = JSON.parse(response.data.footer);
                    }
                } else {
                    this.header = {"color":"#3082cd", "nav":"<b>Pracovní příležitosti</b>", "text":"<h2></h2><h1 style=\"text-align: center;\"><font color=\"#ffffff\"><b>Společně v Název společnosti 2</b></font></h1>", "button":"<font color=\"#ffffff\">Odkaz dolů</font>"};
                    this.body = {"text1":"<h2><b>Rebranding je naše</b></h2><p><br>Pod křídly Company name vzniká <b>největší agentura</b>&nbsp;<span style=\"background-color: transparent; color: var(--default-font-color) ;\">zaměřená na rebranding ve střední Evropě. To jsou v tuto chvíli e-shopy MALL.cz, Vivantis.cz, CZC.cz a jejich pobočky v dalších šesti zemích. Představte si miliony uživatelů a dat, která se každý den hromadí na serverech. Tým Business Intelligence v Mall Group má za cíl vybudovat datovou firemní kulturu a být oponentem a partnerem byznys strategie.</span></p>", "text2":"<h2><span style=\"background-color: transparent; color: var(--default-font-color) ;\"><br></span></h2><h2><span style=\"background-color: transparent; color: var(--default-font-color) ;\"><b>Postavička \"Moore\" je náš firemní maskot.</b></span></h2>", "text3":"<h2><b>Globální ambice</b></h2><div><div><br></div><div>Naším cílem je globální dopad a globální zvuk Feedyou. Chatboty od Feedyou budeš potkávat čím dál častěji, a to nejen u nás, ale i v dalších zemích. Další krok jsou malé jazyky, což jsou všechny mimo angličtinu. Startujeme naše aktivity v Německu a Polsku, kde si ověříme, nakolik jsme schopní replikovat naše služby na jiném trhu. Vzhledem k tomu, že můžeme technologicky konkurovat největším hráčům, nebude náš úspěch záviset jen na naší proaktivitě a dobrých rozhodnutích, ale samozřejmě i trocha toho štěstí potěší. Věříme, že díky tomu, že jsme hodně rychlí, flexibilní a umíme reagovat téměř okamžitě a tím se učit z chyb, jsme připravení na mezinárodní prostředí.&nbsp;</div><div><br></div></div>", "text4":"<p></p><div><h2><b>Jak to všechno začalo</b></h2><b><br></b></div><div><b>Trezor se stal rychle legendou v krypto komunitě a nastartoval vznik odvětví hardwarových peněženek.</b></div><div><b>Věříme, že budoucnost potřebuje svobodnou měnu jakou je Bitcoin, aby se posílila decentralizace a nezávislost lidí. V SatoshiLabs nás vnitřně pohání dvě věci.&nbsp;</b></div><div><br></div><div>Je to láska k Trezoru, o kterém jsme přesvědčeni, že to je skvělý produkt a jehož potenciál je téměř nekonečný. A druhým motorem je snaha o změnu společenských poměrů a spravedlivější rozložení sil. Proto stavíme kolem Bitcoinu infrastrukturu, aby byl pro každého lehce použitelný. Je to láska k Trezoru, o kterém jsme přesvědčeni, že to je skvělý produkt a jehož potenciál je téměř nekonečný. Je to láska k lorem ipsum dolor sit amet lorem o kterém jsme přesvědčeni, že to je skvělý produkt a jehož potenciál je téměř nekonečný.&nbsp;&nbsp;</div><div><br></div><div><b>Pustťe si rozhovor s naším CEO:</b></div><div><br></div> <iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/RLDzdILhjIQ?controls=0\" title=\"YouTube video player\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen=\"\"></iframe><p></p>", "text5":"<p></p><div><p>Je to láska k Trezoru, o kterém jsme přesvědčeni, že to je skvělý produkt a jehož potenciál je téměř nekonečný. A druhým motorem je snaha o změnu společenských poměrů a spravedlivější rozložení sil. Proto stavíme kolem Bitcoinu infrastrukturu, aby byl pro každého lehce použitelný. Je to láska k Trezoru, o kterém jsme přesvědčeni, že to je skvělý produkt a jehož potenciál je téměř nekonečný. Je to láska k lorem ipsum dolor sit amet lorem o kterém jsme přesvědčeni, že to je skvělý produkt a jehož potenciál je téměř nekonečný.&nbsp;</p></div><div><br></div><h3><b>Pustťe si rozhovor s naším CEO:</b></h3><div><br></div> <iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/RLDzdILhjIQ?controls=0\" title=\"YouTube video player\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen=\"\"></iframe><p></p>"};
                    this.fullsize = {"text1":"<h2></h2><h3><font color=\"#ffffff\"><b>Jak se ti líbí v Název společnosti?</b></font></h3><span style=\"color: rgb(247, 247, 247); font-size: 2rem; background-color: transparent;\"><br></span><h3><font color=\"#ffffff\">\"Nejsme na trhu 20 let, nemáme stovkový stravenky a letní sídlo na horách. Ale to, co je pro mě obrovským benefitem, je flexibilita. Můžu tady pracovat, jak já potřebuju, a je na mně, jestli půjdu na pláž na lehátko, do kavárny a nebo budu v kanceláři.\"</font></h3><div><font color=\"#f7f7f7\"><br></font></div><div><font color=\"#f7f7f7\">Moore Pavel, Marketing Specialist</font></div>"};
                    this.prefooter = {"text1":"<h2><b><br><br>Najdete nás v Karlíně</b></h2><br><div>Kanceláře máme pár minut pěšky od <b>Karlínského</b> náměstí,&nbsp;<span style=\"background-color: transparent; color: var(--default-font-color) ;\">ve skvělém kampusu s jezírkem k rozjímání a restaurací k dobrému obědu.&nbsp;</span><span style=\"background-color: transparent;\">🍕 🌮</span></div><div>Přímo v naší cafeterii pak najdeš také vynikající kávu z místní pražírny Upražsi. Často se také pohybujeme v PragueStartupCentre.<br><br>Karlínské náměstí 399, Praha 8<br>info@nazevspolecnosti.cz</div><div>888 777 888</div>", "text2":"<iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2434.223810117095!2d14.448825039110222!3d50.09233172417405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470b94bcc80e9607%3A0xbfd643b598276e9a!2scafe%20frida!5e0!3m2!1scs!2scz!4v1625826115772!5m2!1scs!2scz\" width=\"600\" height=\"450\" style=\"border:0;\" allowfullscreen=\"\" loading=\"lazy\"></iframe>"};
                    this.footer = {"text1":"<h2 style=\"text-align: center; \"><b>Chceš k nám? Tohle u tebe budeme hledat</b></h2>","text2":"<p><b>PŘÍLEŽITOST </b><br>Vidíš taky tu obrovskou příležitost? Hledáme k sobě lidi, kteří jsou z těch možností nadšení stejně jako my.<br><br></p><p><b>MARKETING NENÍ NUDA<br></b><span style=\"background-color: transparent; color: var(--default-font-color) ;\">Vidíš taky tu obrovskou příležitost? Hledáme k sobě lidi, kteří jsou z těch možností nadšení stejně jako my.</span></p>","text3":"<p><b>OTEVŘENÁ HLAVA<br></b>Občas věci prostě nejdou podle plánu. Občas se chybuje víc, než jsi čekal, a musí se to vyřešit. Je dobré s tím počítat a nezpanikařit a mít hlavu otevřenou, protože na řešení tady někde narazíš.</p><p><br><b>CÍLEVĚDOMOST</b><br>Vidíš taky tu obrovskou příležitost? Hledáme k sobě lidi, kteří jsou z těch možností nadšení stejně jako my.</p><p><br></p>","text4":"<h2 style=\"text-align: center; \"><b>Naše benefity</b></h2><h2 style=\"text-align: center; \"><b><br></b></h2><table class=\"table table-bordered\" style=\"text-align: center;\"><tbody><tr><td>5 týdnů dovolené a 5 sickdays</td><td>volný vstup do Pražské zoo</td></tr><tr><td>multisport karta</td><td>dog-friendly office</td></tr></tbody></table><p><br></p>"};
                }


                let root = document.documentElement;
                root.style.setProperty('--careers-color', this.header.color);


                // Place images into the right spot
                if(response.data.images && response.data.updated_at != "2022-01-01T00:01:00.000000Z"){
                    const allImages = JSON.parse(response.data.images);
                    this.inputs.images = allImages; // initial load
                } else {
                    this.inputs.images = {"logo":["\/storage\/site\/60e732d5a185f.png"],"header":["\/storage\/site\/60e80ae86b4b8.jpg"],"body1":["\/storage\/site\/60e8164e5b345.jpg"],"body2":["\/storage\/site\/60e817aa5f56d.jpg"],"body3":["\/storage\/site\/60e81638ea83c.jpg"],"body4":["\/storage\/site\/60e817e2768d6.jpg"],"fullsize":["\/storage\/site\/60e81d3c756dd.jpg"],"prefooter":[],"footer":["\/storage\/site\/60e834bd848d4.jpg"]}
                }

                // Get active adverts
                this.axiosGet('admin/app/jobs?status=1').then(response => {
                    this.adverts = response.data;
                    this.advertsCount = Object.keys(this.adverts).length;
                });


                this.preloader = false;
                this.finishedGetData = true;

            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            clear() {
                this.inputs = {};
                this.fieldStatus = {
                    isSubmit: false
                }
            },

            /**
             * Image upload and set to Chosen Place
             */
            addImageTo(place) {
                this.chosenPlace = place;
                this.$emit('getImageAction', place);
            },
            insertImageToChosenPlace(url){

                if(this.chosenPlace == 'logo'){
                    this.inputs.images.logo = [];
                    this.inputs.images.logo.push(url);
                } else if(this.chosenPlace == 'header'){
                    this.inputs.images.header = [];
                    this.inputs.images.header.push(url);
                } else if (this.chosenPlace == 'body1'){
                    this.inputs.images.body1.push(url);
                } else if (this.chosenPlace == 'body2'){
                    this.inputs.images.body2.push(url);
                } else if (this.chosenPlace == 'body3'){
                    this.inputs.images.body3.push(url);
                } else if (this.chosenPlace == 'body4'){
                    this.inputs.images.body4.push(url);
                } else if (this.chosenPlace == 'fullsize'){
                    this.inputs.images.fullsize.push(url);
                } else if (this.chosenPlace == 'prefooter'){
                    this.inputs.images.prefooter.push(url);
                } else if (this.chosenPlace == 'footer'){
                    this.inputs.images.footer.push(url);
                }

            },
            removeImageFromChosenPlace(url, place){
                if(place == 'logo'){
                    for(var i = 0; i <= this.inputs.images.logo.length - 1; i++){
                        if(this.inputs.images.logo[i] == url){
                            this.inputs.images.logo.splice(i--,1);
                        }
                    }
                } else if(place == 'header'){
                    for(var i = 0; i <= this.inputs.images.header.length - 1; i++){
                        if(this.inputs.images.header[i] == url){
                            this.inputs.images.header.splice(i--,1);
                        }
                    }
                } else if (place == 'body1'){
                    for(var i = 0; i <= this.inputs.images.body1.length - 1; i++){
                        if(this.inputs.images.body1[i] == url){
                            this.inputs.images.body1.splice(i--,1);
                        }
                    }
                } else if (place == 'body2'){
                    for(var i = 0; i <= this.inputs.images.body2.length - 1; i++){
                        if(this.inputs.images.body2[i] == url){
                            this.inputs.images.body2.splice(i--,1);
                        }
                    }
                } else if (place == 'body3'){
                    for(var i = 0; i <= this.inputs.images.body3.length - 1; i++){
                        if(this.inputs.images.body3[i] == url){
                            this.inputs.images.body3.splice(i--,1);
                        }
                    }
                } else if (place == 'body4'){
                    for(var i = 0; i <= this.inputs.images.body4.length - 1; i++){
                        if(this.inputs.images.body4[i] == url){
                            this.inputs.images.body4.splice(i--,1);
                        }
                    }
                } else if(place == 'fullsize'){
                    for(var i = 0; i <= this.inputs.images.fullsize.length - 1; i++){
                        if(this.inputs.images.fullsize[i] == url){
                            this.inputs.images.fullsize.splice(i--,1);
                        }
                    }
                } else if(place == 'prefooter'){
                    for(var i = 0; i <= this.inputs.images.prefooter.length - 1; i++){
                        if(this.inputs.images.prefooter[i] == url){
                            this.inputs.images.prefooter.splice(i--,1);
                        }
                    }
                } else if(place == 'footer'){
                    for(var i = 0; i <= this.inputs.images.footer.length - 1; i++){
                        if(this.inputs.images.footer[i] == url){
                            this.inputs.images.footer.splice(i--,1);
                        }
                    }
                }
            },
            changeColor(){
                let root = document.documentElement;
                root.style.setProperty('--careers-color', this.header.color);
            },
            changeImageOrder(arr, from, to){
                return arr.reduce((prev, current, idx, self) => {
                    if (from === to) {
                      prev.push(current);
                    }
                    if (idx === from) {
                      return prev;
                    }
                    if (from < to) {
                      prev.push(current);
                    }
                    if (idx === to) {
                      prev.push(self[from]);
                    }
                    if (from > to) {
                      prev.push(current);
                    }
                    return prev;
                }, []);
            },



        }
    }
</script>
